import React from 'react';
import get from 'lodash.get';

import { formatAddress } from '../../helpers/text/formatAddress';
import { formatPatientName } from '../../helpers/patient/formatPatientName';
import Address from '../../types/api/address/Address';

import RadioCheckboxBlock from '../_ui/_blocks/Form/Inputs/Legacy/RadioCheckboxBlock/RadioCheckboxBlock';
import Button from '../_ui/_blocks/Buttons/Button/Button';
import Typography from '../_ui/_blocks/Typography/Typography';
import Icon from '../_ui/_blocks/Icon/Icon';

import styles from './AddressPicker.module.css';

interface Props {
    userAddresses: Address[];
    selectedAddress?: Address | undefined;
    onSelect: (address: Address) => void;
    onNew?: (() => void) | null;
}

const AddressPicker = ({ userAddresses, onSelect, selectedAddress = undefined, onNew = null }: Props): JSX.Element => {
    // eslint-disable-line object-curly-newline
    const selectedId = get(selectedAddress, 'uuid') || '';

    return (
        <ul className="space-y-050">
            {userAddresses.map((address) => {
                const isSelected = selectedId === address.uuid.toString();

                const subLabel = (
                    <span>
                        <Typography size="090">{formatAddress(address.address)}</Typography>
                        <br />
                        {address.post_through_letterbox ? (
                            <span className="flex items-center gap-050">
                                <Typography size="080" color="quiet">
                                    Letterbox safe
                                </Typography>
                                <span>
                                    <Icon icon="checkmark-light" alt="checknmark icon" className="pointer-events-none" size="small" />
                                </span>
                            </span>
                        ) : null}
                    </span>
                );

                return (
                    <li key={address.uuid}>
                        <RadioCheckboxBlock
                            id={`form-field--address-${address.uuid}`}
                            name="selected_address"
                            type="radio"
                            label={formatPatientName(address)}
                            subLabel={subLabel}
                            checked={isSelected}
                            onChange={() => onSelect(address)}
                        />
                    </li>
                );
            })}
            {onNew ? (
                <li className="!mt-075">
                    <Button
                        className={styles.NewAddressButton}
                        type="button"
                        onClick={onNew}
                        variant="secondary"
                        title="Add a new delivery address"
                    >
                        <Icon icon="circle-plus-light" alt="crircle plus icon" />
                        New delivery address
                    </Button>
                </li>
            ) : null}
        </ul>
    );
};

export default AddressPicker;
